<template lang="pug">
  label.p-radio.p-radio__label(:class="containerClass" :style="containerStyle")
    input.p-radio__input(
      v-bind="inputAttributes",
      type="radio",
      v-model="state",
      :value="option ? option : label",
      v-on="inputListeners",
      :disabled="disabled || loading",
      :class="classInput"
      ref="radio"
    )
    div.p-radio__indicator
    span(:class="classLabel" :style="estilizacaoCustomizavel") {{ label }}
</template>

<script>
import { handlerUseStateVmodel } from '@/common/mixins/handlerUseStateVmodel'
import {
  extrairAtributosDeControle,
  extrairClasseDoContainer,
  extrairEstiloDoContainer,
  extrairListenersDosAttrs
} from '@/common/mixins/localListenersAndAttributes'

export default {
  name: 'PRadio',
  inheritAttrs: false,
  emits: ['update:modelValue', 'change'],
  mixins: [handlerUseStateVmodel()],
  props: {
    label: { type: String, required: true },
    disabled: Boolean,
    loading: Boolean,
    option: { type: String },
    labelFontSize: { type: String, default: '14px' }
  },
  updated () {
  },
  computed: {
    containerClass () {
      return extrairClasseDoContainer(this.$attrs)
    },
    containerStyle () {
      return extrairEstiloDoContainer(this.$attrs)
    },
    inputListeners () {
      return extrairListenersDosAttrs(this.$attrs)
    },
    inputAttributes () {
      return extrairAtributosDeControle(this.$attrs, ['type', 'disabled', 'value'])
    },
    estilizacaoCustomizavel () {
      return `
        font-size: ${this.labelFontSize};
      `
    },
    classLabel () {
      return {
        'p-radio__label--loading': this.loading,
        'p-radio__label--disabled': this.disabled
      }
    },
    classInput () {
      return {
        'p-radio__input--loading': this.loading,
        'p-radio__input--disabled': this.disabled
      }
    }
  }
}
</script>

<style scoped>

.p-radio {
  position: relative;
  margin-bottom: 5px;
  padding-top: 2px;
  font-size: 14px;
  line-height: 1.35;
  color: var(--texto-forte);
  font-family: var(--texto-tipografia, var(--front-font));
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: grid;
  align-items: center;
  grid-template-columns: 25px 1fr;
  grid-template-rows: auto;
  align-items: center;
  grid-template-areas:
    "indicator label";
}

.p-radio span {
  grid-area: label;
}

.p-radio .p-radio__input {
  position: absolute;
  top: 0;
  left: 0;
  width: 1px;
  height: 1px;
  margin: 0;
  opacity: 0;
}

.p-radio__indicator {
  grid-area: indicator;
  position: relative;
  height: 12px;
  width: 12px;
  background: var(--superficie-cartao);
  border: 1px solid var(--input-cor-habilitado-linha-default, var(--color-default));
  cursor: pointer;
  margin-right: 5px;
}

.p-radio__label .p-radio__indicator {
  border-radius: 50%;
}

.p-radio:hover .p-radio__input:not([disabled]) ~ .p-radio__indicator {
  background: var(--superficie-cartao);
  opacity: .8;
}
.p-radio:hover .p-radio__input:not([disabled]) ~ span,
.p-radio__input:focus ~ span  {
  color: var(--color-primary);
  font-weight: 500;
}

.p-radio:hover .p-radio__input ~ .p-radio__indicator,
.p-radio .p-radio__input:focus ~ .p-radio__indicator{
  background: var(--superficie-cartao);
}

.p-radio .p-radio__input:checked ~ .p-radio__indicator {
  background: var(--superficie-cartao);
}

.p-radio:hover .p-radio__input:not([disabled]):checked ~ .p-radio__indicator,
.p-radio .p-radio__input:checked:focus ~ .p-radio__indicator {
  background: var(--superficie-cartao);
}

.p-radio .p-radio__input:disabled ~ .p-radio__indicator {
  background: var(--superficie-cartao);
  opacity: 0.6;
  pointer-events: none;
}

.p-radio__indicator:after {
  box-sizing: unset;
  content: '';
  position: absolute;
  display: none;
}

.p-radio .p-radio__input:checked ~ .p-radio__indicator:after {
  display: block;
}

.p-radio__label .p-radio__indicator:after {
  top: 1px;
  left: 1px;
  height: 8px;
  width: 8px;
  border-radius: 50%;
  animation: anim-radio-check 0.2s ease;
  animation-fill-mode: forwards;
}

.p-radio__label .p-radio__input:disabled ~ .p-radio__indicator:after {
  border-color: var(--color-default-disabled);
}

.p-radio__label .p-radio__input:disabled ~ .p-radio__indicator {
  border-color: var(--color-default-disabled);
}

.p-radio__label--disabled {
  color: var(--color-default-disabled);
}

.p-radio__label--loading {
  color: transparent;
  background-color: var(--color-default-disabled);
}

@keyframes anim-radio-check {
  0% {
    background: none;
    transform: scale(0);
  }
  80% {
    background: var(--color-primary);
    transform: scale(1.2);
  }
  100% {
    background: var(--color-primary);
    transform: scale(1);
  }
}

</style>
